import { useDispatch } from "react-redux";
import {
  TRACK_COLLECTION_VIEWED_EVENT,
  TRACK_RENAME_COLLECTION_CLICKED,
  TRACK_COLLECTION_RENAMED_EVENT,
  TRACK_CREATE_COLLECTION_CLICKED_EVENT,
  TRACK_SECTION_SELECTED_EVENT,
  TRACK_ADD_LOGO_CLICKED_EVENT,
  TRACK_EXPERIENCE_TYPE_SELECTED_EVENT,
  TRACK_VIEWER_TYPE_SELECTED_EVENT,
  TRACK_CHANGE_EXPERIENCE_CLICKED_EVENT,
  TRACK_COLLECTION_CREATED_EVENT,
  TRACK_COLLECTION_FILTERED_EVENT,
  TRACK_CREATE_FOLDER_CLICKED_EVENT,
  TRACK_FOLDER_CREATED_EVENT,
  TRACK_DELETE_COLLECTION_CLICKED,
  TRACK_COLLECTION_DELETED_EVENT,
  TRACK_CLONE_COLLECTION_CLICKED_EVENT,
  TRACK_CLONE_COLLECTION_CONFIRMATION_EVENT,
  TRACK_COLLECTION_CLONED_EVENT,
  TRACK_EDIT_COLLECTION_CLICKED_EVENT,
  TRACK_LOGO_UPLOADED_EVENT,
  TRACK_EDIT_BANNER_CLICKED_EVENT,
  TRACK_BANNER_CONTENT_SELECTED_EVENT,
  TRACK_CROP_BANNER_CLICKED_EVENT,
  TRACK_BANNER_CROPPED_EVENT,
  TRACK_FILTER_BANNER_CLICKED_EVENT,
  TRACK_BANNER_FILTERED_EVENT,
  TRACK_BANNER_ADDED_EVENT,
  TRACK_ADD_BANNER_CLICKED_EVENT,
  TRACK_ADD_SECTION_CLICKED_COLLECTION_EVENT,
  TRACK_SECTION_ADDED_EVENT,
  TRACK_COLLABORATE_CLICKED_EVENT,
  TRACK_COLLABORATORS_UPDATED_EVENT,
  TRACK_LIVE_COLLECTION_TOGGLE_CLICKED_EVENT,
  TRACK_LIVE_COLLECTION_TOGGLED_EVENT,
  TRACK_TEMPLATE_TOGGLE_CLICKED_EVENT,
  TRACK_INTERNAL_USE_ONLY_CLICKED_EVENT,
  TRACK_INTERNAL_USE_ONLY_TOGGLED_EVENT,
  TRACK_ADD_ASSET_CLICKED_EVENT,
  TRACK_GENERATE_LINK_CLICKED,
  TRACK_SHARE_COLLECTION_CLICKED,
  TRACK_COLLECTION_SHARED_EVENT,
  TRACK_TEMPLATE_TOGGLED_EVENT,
  TRACK_BANNER_LIST_SCREEN_VIEW,
  PAGE_VIEWED,
  TRACK_COLLECTION_CLONE_CONFIRMATION_SCREEN_VIEW,
  TRACK_COLLECTION_EDIT_BANNER_SCREEN_VIEW,
  TRACK_SECTION_CREATE_SCREEN_VIEW,
  TRACK_COLLABORATE_EDIT_SCREEN_VIEW,
  TRACK_LIVE_COLLECTION_CONFIRM_SCREEN_VIEW,
} from "src/constants/adoption/eventTypes";

import { trackEventForAdoption } from "../adoption";
import { BannerChangedEvent, ClonedCollectionEvent, CollectionExperienceChangedEvent, CollectionViewerTypeChangedEvent, InternalUseChangeEvent, LiveCollectionChangeEvent, RenameCollectionEvent, SectionAddedEvent, TemplateChangeEvent } from "src/types/adoption/collections";
import _ from "lodash";
import { Collection, CollectionEditState, CollectionSection } from "src/types/collections";
import { EXPERIENCES } from "src/constants/collections";

export const processViewerType = (viewer: string) => {
  let viewerName = viewer;

  switch (viewer) {
    case 'LIST_VIEWER': {
      viewerName = 'List';
      break;
    }
    case 'IMMERSE_VIEWER': {
      viewerName = 'Immerse';
      break;
    }
    case 'GALLERY_VIEWER': {
      viewerName = 'Gallery';
      break;
    }
    default:
      viewerName = viewer;
  }

  return viewerName;
}

export const useCollectionsAdoption = () => {

  const dispatch = useDispatch();

  //Screen views

  const trackBannerScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        "screen_name": TRACK_BANNER_LIST_SCREEN_VIEW
      }
    };

    dispatch(trackEventForAdoption(event));
  }

  const trackCloneCollectionConfirmationScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        "screen_name": TRACK_COLLECTION_CLONE_CONFIRMATION_SCREEN_VIEW
      }
    };

    dispatch(trackEventForAdoption(event));
  }

  const trackEditBannerScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        "screen_name": TRACK_COLLECTION_EDIT_BANNER_SCREEN_VIEW
      }
    };

    dispatch(trackEventForAdoption(event));
  }

  const trackCreateSectionScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        "screen_name": TRACK_SECTION_CREATE_SCREEN_VIEW
      }
    };

    dispatch(trackEventForAdoption(event));
  }

  const trackCollaborateScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        "screen_name": TRACK_COLLABORATE_EDIT_SCREEN_VIEW
      }
    };

    dispatch(trackEventForAdoption(event));
  }

  const trackLiveCollectionScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        "screen_name": TRACK_LIVE_COLLECTION_CONFIRM_SCREEN_VIEW
      }
    };

    dispatch(trackEventForAdoption(event));
  }

  //Create Collection Clicked 
  const trackCreateCollectionClicked = () => {
    const data = {
      event: TRACK_CREATE_COLLECTION_CLICKED_EVENT,
      properties: {}
    }

    return dispatch(trackEventForAdoption(data));
  }

  // track when user clicks on change experience or next button
  const trackChangeExperienceClickedEvent = (collection?: Collection) => {

    let properties = {};
    if (collection) {
      properties = {
        collection_name: collection.name,
      }
    }

    const event = {
      event: TRACK_CHANGE_EXPERIENCE_CLICKED_EVENT,
      properties: properties
    }

    dispatch(trackEventForAdoption(event));
  }

  // track when user selects an experience type
  const trackExperienceTypeSelectedEvent = (changeEvent: CollectionExperienceChangedEvent) => {
    const { id, name, experience } = changeEvent;

    const source = id ? 'Edit Collection' : 'Create Collection';
    const experienceName = EXPERIENCES.find(item => item.id === experience)?.name;

    const event = {
      event: TRACK_EXPERIENCE_TYPE_SELECTED_EVENT,
      properties: {
        collection_name: name,
        experience_type: experienceName,
        source_cta: source,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // track when user selects an experience type
  const trackViewerTypeSelectedEvent = (changeEvent: CollectionViewerTypeChangedEvent) => {
    const { id, name, viewer } = changeEvent;

    const source = id ? 'Edit Collection' : 'Create Collection';
    const viewerName = processViewerType(viewer);
    const event = {
      event: TRACK_VIEWER_TYPE_SELECTED_EVENT,
      properties: {
        collection_name: name,
        viewer_type: viewerName,
        source_cta: source,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // Track collection created event
  const trackCollectionCreatedEvent = (collection: Collection) => {
    const { name, viewerType, assetViewer } = collection;

    const experienceName = EXPERIENCES.find(item => item.id === viewerType)?.name;
    const viewerName = processViewerType(assetViewer || "");

    const hasAssets = !_.isEmpty(collection.entities);

    const event = {
      event: TRACK_COLLECTION_CREATED_EVENT,
      properties: {
        collection_name: name,
        experience_type: experienceName,
        viewer_type: viewerName,
        isAssetAdded: hasAssets ? 'Yes' : 'No',
        source_cta: 'Create Collection',
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on one of the tabs on the top to view a filtered list of collections
  const trackCollectionsFiltered = (filter: string) => {
    const event = {
      event: TRACK_COLLECTION_FILTERED_EVENT,
      properties: {
        filter_tag: filter
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on the `Create Folder` button
  const trackCreateFolderClicked = () => {
    const event = {
      event: TRACK_CREATE_FOLDER_CLICKED_EVENT,
      properties: {}
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user successfully creates a new folder
  const trackFolderCreated = (folderName: string) => {
    const event = {
      event: TRACK_FOLDER_CREATED_EVENT,
      properties: {
        folder_name: folderName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on the `Rename` button
  const trackRenameCollectionClicked = () => {
    const event = {
      event: TRACK_RENAME_COLLECTION_CLICKED,
      properties: {}
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user successfully renames a collection by clicking on the `Save` after renaming a collection
  const trackCollectionRenamed = (renameEvent: RenameCollectionEvent) => {
    const { oldName, newName } = renameEvent;

    const event = {
      event: TRACK_COLLECTION_RENAMED_EVENT,
      properties: {
        old_name: oldName,
        new_name: newName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on the `Delete` button
  const trackDeleteCollectionClicked = () => {
    const event = {
      event: TRACK_DELETE_COLLECTION_CLICKED,
      properties: {}
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user successfully deletes a collection by clicking on the `Delete` after selecting a collection
  const trackCollectionDeleted = (collectionName: string) => {
    const event = {
      event: TRACK_COLLECTION_DELETED_EVENT,
      properties: {
        collection_name: collectionName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on `Clone` button
  const trackCloneCollectionClicked = () => {
    const event = {
      event: TRACK_CLONE_COLLECTION_CLICKED_EVENT,
      properties: {}
    }

    dispatch(trackEventForAdoption(event));
  }

  /**
   * When the user clicks on the `Confirm` button on the confirmation screen 
   * that shows up for cloning an existing collection
   */

  const trackCloneCollectionConfirmed = (collectionName: string) => {
    const event = {
      event: TRACK_CLONE_COLLECTION_CONFIRMATION_EVENT,
      properties: {
        collection_name: collectionName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user successfully creates an new collection by cloning an existing collection
  const trackCollectionCloned = (cloneEvent: ClonedCollectionEvent) => {
    const { sourceName, clonedName } = cloneEvent;

    const event = {
      event: TRACK_COLLECTION_CLONED_EVENT,
      properties: {
        collection_name: sourceName,
        cloned_collection_name: clonedName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user views the details of a collectionby clicking on the tile of one collection
  const trackCollectionViewed = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const name = collection.name;

    const event = {
      event: TRACK_COLLECTION_VIEWED_EVENT,
      properties: {
        collection_name: name,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on 'Edit Collection' on the 'Colection Detail' screen
  const trackEditCollectionClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const name = collection.name;

    const event = {
      event: TRACK_EDIT_COLLECTION_CLICKED_EVENT,
      properties: {
        collection_name: name,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on the `Add Logo` buton on the 'Collection Detail' screen
  const trackAddLogoClickedEvent = (collectionName?: string) => {
    if (collectionName == null) {
      console.warn("Collection name is null");
      return;
    }

    const event = {
      event: TRACK_ADD_LOGO_CLICKED_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user successfully uploads a selected logo for a collection
  const trackAddLogoUploaded = (collectionName?: string) => {
    if (collectionName == null) {
      console.warn("Collection name is null");
      return;
    }

    const event = {
      event: TRACK_LOGO_UPLOADED_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on `Edit Banner` button in the 'Collection Detail' screen
  const trackEditBannerClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const event = {
      event: TRACK_EDIT_BANNER_CLICKED_EVENT,
      properties: {
        collection_name: collection.name,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user successfully adds a banner from the selection
  const trackBannerContentSelected = (chnagedEvent: BannerChangedEvent) => {
    const { collection, media } = chnagedEvent;

    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    if (media == null) {
      console.warn("Media is null");
      return;
    }

    const mediaType = media.type == 'image' ? 'Image' : 'Video';

    const event = {
      event: TRACK_BANNER_CONTENT_SELECTED_EVENT,
      properties: {
        collection_name: collection.name,
        banner_type: mediaType,
        source_cta: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on the `Crop` button in the banner edit menu
  const trackCropBannerClicked = (collection?: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const media = _.get(collection, 'banner.background');
    if (media == null) {
      console.warn("Media is null");
      return;
    }

    const event = {
      event: TRACK_CROP_BANNER_CLICKED_EVENT,
      properties: {
        collection_name: collection.name,
        banner_type: 'Image',
        source_cta: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user successfully crops a banner
  const trackBannerCropped = (collection?: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const media = _.get(collection, 'banner.background');
    if (media == null) {
      console.warn("Media is null");
      return;
    }

    const event = {
      event: TRACK_BANNER_CROPPED_EVENT,
      properties: {
        collection_name: collection.name,
        banner_type: 'Image',
        source_cta: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When a user clicks on the `Filter` button in edit banner menu
  const trackFilterBannerClicked = (collection?: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const media = _.get(collection, 'banner.background');
    if (media == null) {
      console.warn("Media is null");
      return;
    }

    const mediaType = media.type == 'image' ? 'Image' : 'Video';

    const event = {
      event: TRACK_FILTER_BANNER_CLICKED_EVENT,
      properties: {
        collection_name: collection.name,
        banner_type: mediaType,
        source_cta: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When a user successfully filters a banner
  const trackBannerFiltered = (collection?: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const media = _.get(collection, 'banner.background');
    if (media == null) {
      console.warn("Media is null");
      return;
    }

    const mediaType = media.type == 'image' ? 'Image' : 'Video';

    const event = {
      event: TRACK_BANNER_FILTERED_EVENT,
      properties: {
        collection_name: collection.name,
        banner_type: mediaType,
        source_cta: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on `Upload` button in the edit banner menu 
  const trackAddBannerClicked = (collection?: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const event = {
      event: TRACK_ADD_BANNER_CLICKED_EVENT,
      properties: {
        collection_name: collection.name,
        source_cta: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user successfully uploads a banner
  const trackBannerAdded = (chnagedEvent: BannerChangedEvent) => {
    const { collection, media } = chnagedEvent;
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const mediaType = media.type == 'image' ? 'Image' : 'Video';

    const event = {
      event: TRACK_BANNER_ADDED_EVENT,
      properties: {
        collection_name: collection.name,
        banner_type: mediaType,
        source_cta: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on the `Add Section` buton in the edit menu
  const trackAddSectionClicked = (collection: Collection | CollectionEditState) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_ADD_SECTION_CLICKED_COLLECTION_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user adds a section successfully by clicking on confirm button
  const trackSectionAdded = (addEvent: SectionAddedEvent) => {
    const { collection, section } = addEvent;

    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    if (section == null) {
      console.warn("Section name is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_SECTION_ADDED_EVENT,
      properties: {
        collection_name: collectionName,
        section_name: section
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user selects a section inside a collection by clicking on the section 
  const trackSectionSelected = (collection: Collection, section: CollectionSection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    if (section == null) {
      console.warn("Section is null");
      return;
    }

    const collectionName = collection.name;
    const sectionName = section.name;

    const event = {
      event: TRACK_SECTION_SELECTED_EVENT,
      properties: {
        collection_name: collectionName,
        section_name: sectionName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on the `Collaborate` toggle button
  const trackCollaborateClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_COLLABORATE_CLICKED_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks and updates the collaborators and their respective permission for a collection
  const trackCollaboratorsUpdated = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;
    const event = {
      event: TRACK_COLLABORATORS_UPDATED_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on the `Live Collection` toggle button
  const trackLiveCollectionToggleClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_LIVE_COLLECTION_TOGGLE_CLICKED_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user confirms the change in the `Live` status as ON or OFF
  const trackLiveCollectionToggled = (changeEvent: LiveCollectionChangeEvent) => {
    const { collection, live, notifyRecipients } = changeEvent;

    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;
    const event = {
      event: TRACK_LIVE_COLLECTION_TOGGLED_EVENT,
      properties: {
        collection_name: collectionName,
        live_status: live ? 'on' : 'off',
        notify_recipients: notifyRecipients ? 'yes' : 'no'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on the `Template` toggle button
  const trackTemplateToggleClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_TEMPLATE_TOGGLE_CLICKED_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user confirms the change in the `Template` status as ON or OFF
  const trackTemplateToggled = (changeEvent: TemplateChangeEvent) => {
    const { collection, template } = changeEvent;

    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;
    const event = {
      event: TRACK_TEMPLATE_TOGGLED_EVENT,
      properties: {
        collection_name: collectionName,
        template_status: template ? 'on' : 'off',
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on the `Internal Use Only` toggle button
  const trackInternalUseToggleClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_INTERNAL_USE_ONLY_CLICKED_EVENT,
      properties: {
        collection_name: collectionName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user confirms the change in the `Internal Use Only` status as ON or OFF
  const trackInternalUserToggled = (changeEvent: InternalUseChangeEvent) => {
    const { collection, internal } = changeEvent;

    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;
    const event = {
      event: TRACK_INTERNAL_USE_ONLY_TOGGLED_EVENT,
      properties: {
        collection_name: collectionName,
        internal_use_only: internal ? 'on' : 'off',
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on the `Add Asset` button in the menu
  const trackAddAssetClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_ADD_ASSET_CLICKED_EVENT,
      properties: {
        collection_name: collectionName,
        add_type: 'Collection'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // When the user clicks on the `Generate Link` button in the menu
  const trackGenerateLinkClicked = (collection: Collection) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    const event = {
      event: TRACK_GENERATE_LINK_CLICKED,
      properties: {
        collection_name: collectionName,
        source_cta: 'Collections Detail'
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user clicks on the `Share Collection` button in the menu
  const trackShareCollectionClicked = (collection: Collection, source: string) => {
    if (collection == null) {
      console.warn("Collection is null");
      return;
    }

    const collectionName = collection.name;

    let sourceType = source;
    switch (source) {
      case 'email':
        sourceType = 'Email';
        break;
      case 'linkedin':
        sourceType = 'LinkedIn';
        break;
      case 'facebook':
        sourceType = 'Facebook';
        break;
      case 'twitter':
        sourceType = 'Twitter';
        break;
      default:
        sourceType = source;
    }

    const event = {
      event: TRACK_SHARE_COLLECTION_CLICKED,
      properties: {
        collection_name: collectionName,
        share_medium: sourceType
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //When the user successfully shares the collection
  const trackCollectionShared =  ({name, shareMedium }: Collection) => {
    const event = {
      event: TRACK_COLLECTION_SHARED_EVENT,
      properties: {
        collection_name: name,
        share_medium: shareMedium
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  return {
    trackBannerScreenView,
    trackCloneCollectionConfirmationScreenView,
    trackEditBannerScreenView,
    trackCreateSectionScreenView,
    trackCollaborateScreenView,
    trackLiveCollectionScreenView,

    trackCreateCollectionClicked,
    trackChangeExperienceClickedEvent,
    trackExperienceTypeSelectedEvent,
    trackViewerTypeSelectedEvent,
    trackCollectionCreatedEvent,

    trackCollectionsFiltered,
    trackCreateFolderClicked,
    trackFolderCreated,

    trackRenameCollectionClicked,
    trackCollectionRenamed,

    trackDeleteCollectionClicked,
    trackCollectionDeleted,

    trackCloneCollectionClicked,
    trackCloneCollectionConfirmed,
    trackCollectionCloned,

    trackCollectionViewed,

    trackEditCollectionClicked,

    trackAddLogoClickedEvent,
    trackAddLogoUploaded,

    trackEditBannerClicked,
    trackBannerContentSelected,
    trackCropBannerClicked,
    trackBannerCropped,
    trackFilterBannerClicked,
    trackBannerFiltered,
    trackAddBannerClicked,
    trackBannerAdded,

    trackAddSectionClicked,
    trackSectionAdded,
    trackSectionSelected,

    trackCollaborateClicked,
    trackCollaboratorsUpdated,

    trackLiveCollectionToggleClicked,
    trackLiveCollectionToggled,

    trackTemplateToggleClicked,
    trackTemplateToggled,

    trackInternalUseToggleClicked,
    trackInternalUserToggled,

    trackAddAssetClicked,

    trackGenerateLinkClicked,
    trackShareCollectionClicked,
    trackCollectionShared,
  }
};